import featureConfigHelper from 'helpers/featureConfigHelper';

const featureConfig = new featureConfigHelper();

export const menuBarItems = [
    {
        route: '/fleet-dashboard',
        title: 'ABB.Powertrain.Frontend.ptHomeMainMenu'
    },
    {
        route: '/conditionmonitor',
        title: 'ABB.Powertrain.Frontend.ptInsightsOverviewMainMenu'
    },
    ...featureConfig.isReportsFeatureEnabled() ? [
        {
            route: '/reports',
            title: 'ABB.Powertrain.Frontend.ptReportsMainMenu'
        }] : [],
    {
        route: '/tools',
        title: 'ABB.Powertrain.Frontend.ptToolsMainMenu'
    },
];
